import React, { useState, useEffect } from 'react';

import 'materialize-css';
import '../styles/nav.scss'

import LaunchIcon from '@mui/icons-material/Launch';
import ReportIcon from './ReportIcon';
import LookupIcon from './LookupIcon';
import ScheduleIcon from './ScheduleIcon';
import OrderIcon from './OrderIcon';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import LogoutIcon from '@mui/icons-material/Logout';
import PestControlIcon from '@mui/icons-material/PestControl';
import PlaygroundIcon from '@mui/icons-material/Fort';
import MapIcon from '@mui/icons-material/Map';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ColorSchemePicker from './ColorSchemePicker';
import GlassContainer from './GlassContainer';
import KeyboardDoubleArrowRightRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowRightRounded';

import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../redux/actions';

import { Textfit } from 'react-textfit';
import { getThemeClass, applySchemeClass, clearSchemeClasses } from '../utils/themeUtils';

const RAIL_PINNED_KEY = 'navRailPinned';

const Nav = (props) => {
  const [pickerOpen, setPickerOpen] = useState(false);
  const [colorPickerOpen, setColorPickerOpen] = useState(false);

  const active = (screen) => {
    const defaultScreen = 'lookup';
    if (props.location === '' && screen === defaultScreen) {
      return 'active';
    } else {
      return props.location === screen ? 'active' : null;
    }
  }

  const allTabs = [
    {
      name: 'lookup',
      colorScheme: props.user?.lookup_color_scheme,
      icon: LookupIcon,
      url: '/lookup'
    }, {
      name: 'reports',
      colorScheme: props.user?.reports_color_scheme,
      icon: ReportIcon,
      url: '/reports'
    }, {
      name: 'quotes',
      colorScheme: props.user?.quotes_color_scheme,
      icon: RequestQuoteIcon,
      url: '/quotes'
    }, /* {
      name: 'schedule',
      colorScheme: props.user?.schedule_color_scheme,
      icon: ScheduleIcon,
      url: '/schedule'
    // }, */ {
    //   name: 'map',
    //   colorScheme: props.user?.map_color_scheme,
    //   icon: MapIcon,
    //   url: '/map'
    // }, {
      name: 'orders',
      colorScheme: props.user?.orders_color_scheme || 'slate',
      icon: OrderIcon,
      url: '/orders'
    }
  ]

  if (props.user?.admin && !props.user?.operator) {
    allTabs.push({
      name: 'admin',
      colorScheme: 'slate',
      icon: AdminPanelSettingsIcon,
      url: '/admin'
    });
  }

  const tabs = props.user?.operator ? allTabs.filter(tab => tab.name === 'reports') : allTabs;

  const getThemeClassForLocation = () => {
    const location = props.location || 'lookup';
    const user = props.user;

    if (!user) return getThemeClass('slate'); // Grey theme when user isn't loaded

    // Routes can be hidden from the rail (map, schedule) and still need a scheme.
    const schemes = {
      lookup: user.lookup_color_scheme,
      reports: user.reports_color_scheme,
      quotes: user.quotes_color_scheme,
      schedule: user.schedule_color_scheme,
      map: user.map_color_scheme || 'ocean',
      orders: user.orders_color_scheme || 'slate',
      admin: 'slate',
    };

    return getThemeClass(schemes[location] || tabs.find(tab => tab.name === location)?.colorScheme);
  }

  const toggleColorPicker = () => {
    setPickerOpen(prevState => !prevState);
  }

  const handleSidebarMouseLeave = () => {
    setColorPickerOpen(false);
  }

  const handleColorPickerToggle = (isOpen) => {
    setColorPickerOpen(isOpen);
  }

  const themeClass = props.nav ? getThemeClassForLocation() : null;

  useEffect(() => {
    if (!themeClass) {
      clearSchemeClasses(document.body);
      return undefined;
    }

    applySchemeClass(document.body, themeClass);
    return () => clearSchemeClasses(document.body);
  }, [themeClass]);

  console.log('props.location', props.location)
  if (!props.nav) {
    return props.children;
  }

  return (
      <div className={`nav-background ${props.location || 'lookup'} ${themeClass}`}>
        <div className="nav-wrapper">
          <nav
            className={`nav-sidebar`}
            aria-label="Primary"
            onMouseLeave={handleSidebarMouseLeave}
          >
            {tabs.map(tab => {
              const label = tab.name.charAt(0).toUpperCase() + tab.name.slice(1);
              const isActive = Boolean(active(tab.name));

              return (
                <a
                  key={tab.name}
                  className={`nav-btn ${tab.name} ${isActive ? 'active' : ''} ${themeClass}`}
                  href={tab.url}
                  aria-current={isActive ? 'page' : undefined}
                >
                  <tab.icon className="nav-icon" />
                  <span className="nav-text">{label}</span>
                </a>
              );
            })}

            <div className={"spacer"}/>

            {props.location !== 'admin' && (
              <ColorSchemePicker
                page={props.location} 
                placement="above" 
                className="nav-btn color-picker"
                isOpen={colorPickerOpen}
                onToggle={handleColorPickerToggle}
              >
                <span className="nav-text">Colors</span>
              </ColorSchemePicker>
            )}

            <button
              className={"nav-btn logout"}
              onClick={() => {
                // clearSession nulls the authToken in Redux and clears
                // localStorage; App.js then renders <Login /> automatically.
                props.clearSession();
                window.history.replaceState({}, '', '/');
              }}
            >
              <LogoutIcon className="nav-icon" />
              <span className="nav-text">Logout</span>
            </button>
          </nav>
          <div className="everything-else">
            <div className="page-wrapper">
              {props.children}
            </div>
          </div>
        </div>
      </div>
    );
}

function mapStateToProps(state, props) {
  return {
    navHeader: state.navHeader,
    user: state.user,
    nav: state.showNav
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Nav);